module.exports = __webpack_public_path__ + "static/media/slotsRouletteIn.77d93d64.png";